/**
 * @generated SignedSource<<3e83c8471387b3c6e1aeac35b8c5f77f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeactivateHistoryTable_integration$data = {
  readonly integrationScriptResults: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly platform: string;
        readonly " $fragmentSpreads": FragmentRefs<"DeactivateHistoryTableRow_integrationScriptResult" | "DeactivateHistoryContextMenu_integrationScriptResult">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "DeactivateHistoryTable_integration";
};
export type DeactivateHistoryTable_integration$key = {
  readonly " $data"?: DeactivateHistoryTable_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeactivateHistoryTable_integration">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "integrationScriptResults"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./DeactivateHistoryTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "DeactivateHistoryTable_integration",
  "selections": [
    {
      "alias": "integrationScriptResults",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "IntegrationScriptResultsConnection",
      "kind": "LinkedField",
      "name": "__DeactivateHistoryTable_integrationScriptResults_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationScriptResultsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationScriptResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "platform",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeactivateHistoryTableRow_integrationScriptResult"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeactivateHistoryContextMenu_integrationScriptResult"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__DeactivateHistoryTable_integrationScriptResults_connection(orderBy:\"CREATED_AT_DESC\")"
    },
    (v1/*: any*/)
  ],
  "type": "Integration",
  "abstractKey": null
};
})();

(node as any).hash = "abcc341114c8b5fc34ceca9cc02eb1c8";

export default node;
